'use es6';

import { PAGES_FETCH, PAGES_FETCH_BY_ID, PAGES_CACHE_CLEAR, PAGES_SAVE_CACHED_PAGE } from 'simple-menus-core/actions/ActionTypes';
import * as PagesClient from 'simple-menus-core/api/Pages';
import { getCachedPage } from 'simple-menus-core/selectors/pages';
import http from 'hub-http/clients/apiClient';
export function fetchPages(query) {
  const {
    request,
    receive,
    error
  } = fetchPages;
  return (dispatch, getState, {
    httpClient = http
  } = {}) => {
    dispatch(request());
    return PagesClient.fetch(query, httpClient).then(result => {
      dispatch(receive(result));
      return result;
    }).catch(__error => {
      dispatch(error(__error));
      return __error;
    });
  };
}
fetchPages.request = () => {
  return {
    type: PAGES_FETCH
  };
};
fetchPages.receive = result => {
  return {
    type: PAGES_FETCH,
    result
  };
};
fetchPages.error = error => {
  return {
    type: PAGES_FETCH,
    error
  };
};
export function fetchPagesById(id) {
  const query = {
    id
  };
  const {
    request,
    receive,
    error
  } = fetchPagesById;
  return (dispatch, getState, {
    httpClient = http
  } = {}) => {
    dispatch(request());
    return PagesClient.fetch(query, httpClient).then(result => {
      dispatch(receive(result));
      return result;
    }).catch(__error => {
      dispatch(error(__error));
      return __error;
    });
  };
}
fetchPagesById.request = () => {
  return {
    type: PAGES_FETCH_BY_ID
  };
};
fetchPagesById.receive = result => {
  return {
    type: PAGES_FETCH_BY_ID,
    result
  };
};
fetchPagesById.error = error => {
  return {
    type: PAGES_FETCH_BY_ID,
    error
  };
};
export function clearCache() {
  return {
    type: PAGES_CACHE_CLEAR
  };
}
export function saveCachedPage(pageLinkId) {
  return (dispatch, getState) => {
    const page = getCachedPage(getState(), {
      pageLinkId
    });
    dispatch({
      type: PAGES_SAVE_CACHED_PAGE,
      page
    });
  };
}